import type { Company } from '../companies/company';

export interface SelectItem {
  value: number;
  label: string;
}

export function fromCompany(companies: Company[]): SelectItem[] {
  return companies.map(company => ({
    value: company.id,
    label: company.name,
  }));
}
